import SecurityIcon from '@mui/icons-material/GppGood'
import { Box } from '@mui/material'
import { Chip } from '@rentspree/component-2023.components.atoms.chip'
import { Typography } from '@rentspree/component-2023.components.atoms.typography'

import { RentSpreeSoc2CertifiedLogo } from 'constant/icons'

import styles from './footer-soc2-certified.module.scss'

export const FooterSoc2Certified: React.FC = () => (
  <Box className={styles.footerSoc2CertifiedContainer}>
    <img src={RentSpreeSoc2CertifiedLogo} alt="Soc2 Certified Logo" height="40px" width="auto" />
    <Box className={styles.footerSoc2CertifiedTextContainer}>
      <Chip
        className={styles.footerSoc2CertifiedBadge}
        color="secondary"
        size="small"
        startIcon={<SecurityIcon />}
        label="Security"
      />
      <Typography className={styles.footerSoc2CertifiedText} variant="caption">
        SOC2 Type II Certified
      </Typography>
    </Box>
  </Box>
)
